import { defineComponent as _defineComponent } from 'vue'
import { DdPage, DeletedDdPage } from "@/CodegenTypes";
import { formatDollar } from "@/helpers/formatDollar";
import { useTranslation } from "@/store/translation";
import { times } from "lodash";
import { computed, ref, watch } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'DdEntryTables',
  props: {
    page: null,
    checkedEntries: null,
    showDelete: { type: Boolean }
  },
  emits: ["update:checkedEntries"],
  setup(__props: any, { emit }: { emit: ({
  (e: "update:checkedEntries", val: number[]): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  page: DdPage | DeletedDdPage;
  checkedEntries?: number[];
  showDelete?: boolean;
};



const startIndex = ref(0);
const PER_PAGE = 40;
const rowsPerTable = PER_PAGE / 2;
const { $t } = useTranslation();


const localCheckedEntries = ref([] as number[]);



watch(
  () => props.checkedEntries,
  (val) => {
    localCheckedEntries.value = val || [];
  }
);

watch(
  () => localCheckedEntries.value,
  (val) => {
    emit("update:checkedEntries", val);
  }
);

const totalEntriesCount = computed(() => {
  return props.page.entries.length;
});

const entriesInPage = computed(() => {
  const endIndex = startIndex.value + PER_PAGE;
  return props.page?.entries.slice(startIndex.value, endIndex).map((entry) => {
    return {
      ...entry,
      big: entry.big ? Math.round(entry.big * 100) / 100 : "",
      small: entry.small ? Math.round(entry.small * 100) / 100 : "",
    };
  });
});

const entriesInFirstTable = computed(() => {
  if (!entriesInPage.value) {
    return [];
  }
  const dataRows = entriesInPage.value.slice(0, rowsPerTable);
  const rowsToPad = rowsPerTable - dataRows.length - 1;
  const padRows = [] as any[];
  times(rowsToPad, () => {
    padRows.push({ number: "", big: "", small: "", mode: "", amount: "" });
  });
  return [...dataRows, ...padRows];
});

const entriesInSecondTable = computed(() => {
  if (!entriesInPage.value) {
    return [];
  }
  const dataRows = entriesInPage.value.slice(rowsPerTable);
  const rowsToPad = rowsPerTable - dataRows.length - 1;
  const padRows = [] as any[];
  times(rowsToPad, () => {
    padRows.push({ number: "", big: "", small: "", mode: "", amount: "" });
  });
  return [...dataRows, ...padRows];
});

return { __sfc: true,props, startIndex, PER_PAGE, rowsPerTable, $t, localCheckedEntries, emit, totalEntriesCount, entriesInPage, entriesInFirstTable, entriesInSecondTable, formatDollar }
}

})